<template>
    <div class="wrapper">
         <div class="shop_list"  v-if="receiptList.length>0">
            <scroll  :allLoaded="allLoaded"
                    :data="receiptList"
                    @pulldown="loadData"
                    @loadUp="loadup" >
                <div class="cell" v-for="(item,i) in receiptList"
                    append="tree"
                    :index="i"
                    :key="i"   :ref="'cell'+i">
                    <div class="invoice_container" @click="toInvoiceDetail(item.id)">
                        <div class="invoice_column">
                                <!-- -->
                                <span class="invoice_title">{{item.orderTypeName}} </span>
                                <!--  -->
                                <span class="invoice_date">{{item.createTime | formatTime}}</span>
                        </div>
                        <div class="invoice_column flex_end">
                            <div class="invoice_row">
                                <!-- -->
                                <span class="invoice_status">{{receiptStatus[item.receiptStatus]}} </span>
                                <img class="invoice_arrow" :src="arrow" />
                            </div>
                            <div class="invoice_row  price_container">
                                <!--  -->
                                <span class="invoice_price">{{item.receiptAmount}}</span>
                                <span class="unit">元</span>
                            </div>
                        </div>
                    </div>
                </div>
            </scroll>
         </div>
          <div class="noMess" v-if="receiptList.length==0 && loaded">
            <no-message></no-message>
          </div>
    </div>
</template>
<!--<style src="../css/refresh.css" scoped></style>-->
<style scoped>
    .wrapper {
        flex: 1;
        height: 100vh;
        width: 750px;
        display: flex;
    }
    .shop_list {
        flex: 1;
        height: 100vh;
    }
    .noMess{
        margin-top:100px;
        margin-left: 300px;
    }


    .unit {
        font-size: 24px;
        margin-top: 8px;
    }


    /*invoice item style*/
    .invoice_container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 174px;
        margin-left: 40px;
        margin-right: 40px;
        border-bottom-color: #EAEAEA;
        border-bottom-style: solid;
        border-bottom-width: 2px;
    }

    .invoice_title {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
    }

    .invoice_date {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 40px;
        margin-top: 14px;
    }

    .invoice_price {
        font-size: 36px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 50px;
    }

    .invoice_status {
        height: 32px;
        font-size: 24px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(0, 135, 255, 1);
        line-height: 34px;
    }

    .invoice_column {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .invoice_row {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .flex_end {
        align-items: flex-end;
    }

    .price_container {
        margin-top: 12px;
    }

    .invoice_arrow {
        width: 11px;
        height: 20px;
        margin-left: 16px;
    }
</style>

<script>
    import Scroll from "../../components/scroll";
    import NoMessage from "../../components/nomessage";
    import util from '../../utils/util';
    import {getReceiptList} from '../../utils/api';
    import { mapState } from "vuex";
    export default {
        name: "invoiceHistory",
        components: {
            Scroll,
            NoMessage
        },
        computed: {
            ...mapState({
                    common: state => state.common
            })
        },
        data: function() {
        return {
                    index: 1,
                    allLoaded:true,
                    arrow:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAqCAYAAACpxZteAAADdklEQVRYR72Xy09USRSHf6fubUNMBuKD2c9q4m4SuPf2ypVxgomZMUYGARGdUaOyNdFdq8TXX2CUlY//AIbG1lEQ6G5yYUHCxhd08JGo4IqE4Nz6TYrQpKe5l37w6GV3V311vqo655Rgiz+Sn398fHxfEARxrbVYlvXCcZx3m8FeBoyNjf1CsgfAzwDMd++VUl2O4zzdKEQSiYRqamq6BODmyuT5OedItiaTyaeJREJXCxLf92Na66skrxRNQpJvRaTL87yBqgFmYCaTOSEidwHsLIaIyCcAHa7rPqsGsrwHmUymVkQeAzgEQBVPJCJfRaS1r6/vWaW6Vk9RNpvdIyK3zGpJ7iiOBMAbkl3xePxJJZGsAsyg0dHR3ZZl3SD5l4hYIZCPJE/E4/Hn5UL+BzCDViJ5SPLXKF1BEBwfGBj4pxxdawAG4vv+XpK3tNYdAGIhG/9aa210pUpFEgowg6ampnYvLCzcJPkngDBdH0Sk3XXdwfUgkYACXY9IHozQ9YVkS39//4soXesCDGRoaKi+pqbmNsn2MF0AXiulLkallZKAgkiMrtPr6GpzXXdozR0qtUn5383Ga63N6YrUpZT6o7e3d7BQV1kR5CETExP1S0tLd0SkLeJ0vQJwsTCtVATI6wJwG0BnlC4ArZ7nvTT/rxiQvydBEJjcdSDsdAH4LCLHHMd5WRXAQEZGRn60bfsOyTYRsUPSSlZEjlQNKIjE6DoZous7yf0bBdQFQWAq4dkQwL8AqgdsqSKTcQGYJuFwyMohIl+01u2e56UqVuT7fp3W2tSMc2HHVETmlFLNjY2NyzWjIsCWXjRT7Wzbvk/ytwgtpm53TE9PP2lubg7yx7asCFKpVF1tbW03gPNRWgC0hHUeJQErSc5cqM1P16W0AJgzlyyXyyULtRTe6sgITK9kWVZ3EAQXIjqMeaVUS6n+dfuL/uTk5K7FxcX7WuvfQ1ZuLpFpijtzuVx/lJZIRUYLgOumaERo+UbyeCXd3fa0jsPDwz/EYrEekkfDtACYF5HOmZmZv8vRskZROp1uU0rdC2vfAXyzbbu1oaGhqjdC/gFyjeTl4qq0KQ8Qksr3/ctaa5MKCo/tvNb61OzsbF+lWtYoymazjSQfAPhJZJlhEtcZ13WT5fZNUf9bXXE6nd5nWZZnohCRwU19xm50leuN/w/gsNFGcnfzOAAAAABJRU5ErkJggg==',
                    bgColor:"#FFFFFF",
                    receiptStatus: ["开票状态", "已申请", "已开票", "开票失败","已冲销"],
                    receiptList: [],
                    isLoding:false,
                    loaded:false

                };
        },
        created() {
            // globalEvent.addEventListener("clickEvent", (e) => {
            //     if (e.backKey && e.backKey == 'keyPress') this.goBack();
            // })
            this.getReceiptList()
        },
        methods: {

            getReceiptList() {
                let self = this;
                let params = {
                    "pageNo": this.index,
                    "pageSize": 10
                }
               // this.receiptList=[{},{},{},{}]
               this.isLoding =true;
               getReceiptList(params).then(ret => {
                    this.loaded =true;
                    this.isLoding =false;
                    if (ret.res.code == '10000') {
                        if (ret.body.receiptList) {
                            // this.receiptList = ret.body.receiptList;
                            if (this.index === 1) {
                                this.receiptList = ret.body.receiptList
                            } else {
                                if (ret.body.receiptList.length > 0) {
                                    this.receiptList = this.receiptList.concat(ret.body.receiptList)
                                }else {
                                   // modal.toast({message: "已经到底了", duration: 1})
                                }
                            }
                            if(ret.body.receiptList.length!=10){
                                    this.allLoaded =true;
                            }else{
                                    this.allLoaded =false
                            }
                        }
                    } else {
                       // modal.toast({message: ret.res.msg, duration: 1})
                    }
                })

            },
            loadData(){
                console.log("in loadData");
                if(this.isLoding){
                    return;
                }
                this.index=1;
                this.allLoaded =false;
                this.getReceiptList();
            },

            //上拉
            loadup(){
                console.log("in loadup");
                if(this.isLoding){
                    return;
                }
                if(this.allLoaded==true){
                    return;
                }
                this.index=this.index+1;
                this.getReceiptList();
            },
            toInvoiceDetail(id) {
                var url ="/invoiceDetail?id="+id;
                this.$router.push({path:url});
            },

        },
        filters: {
            formatTime: function (value) {
                // let time = configObj.dataFormat(new Date(value), 'yyyy-MM-dd hh:mm');
                // return time;
                 return util.formatTime(new Date(value),10)
            }
        }
    }
</script>